// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"d2b0ef10","416":"6b0eb1f7","480":"ffe6f194","787":"057a11fe","791":"f1447960","801":"4d517408","934":"e1ba61a5"}[chunkId] + ".chunk.js";
};